import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckoutDetail } from "./CheckoutDetail";
import { useMemberStore } from "@/features/auth/stores/member-store";

interface Plan {
  id: string;
  name: string;
  price: string | number;
  rawPrice: number;
  category: string;
  description: string;
}

export function CheckoutPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useMemberStore();
  const plan = location.state?.plan as Plan | undefined;

  if (!plan) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>상품 정보를 불러올 수 없습니다.</p>
        <button onClick={() => navigate("/subscription")}>돌아가기</button>
      </div>
    );
  }

  const price = plan.rawPrice;
  const vat = Math.round(price * 0.1);
  const total = price + vat;
  const userEmail = user?.email || "user@example.com";

  return (
    <CheckoutDetail
      planId={plan.id}
      planName={plan.name}
      price={price}
      vat={vat}
      total={total}
      userEmail={userEmail}
      planCategory={plan.category}
    />
  );
}

export default CheckoutPage;
